import React, { FC, useMemo, useRef } from 'react';

import { MdMoveDown, MdMoveUp } from 'react-icons/md';

import { Box, Button, Center, Flex, Heading, Text } from '@chakra-ui/react';

import {
  TransferModalRef,
  TransferFormModal,
} from 'components/modules/TransferFormModal';
import { UserPill } from 'components/core/UserPill';
import { DataTable } from 'components/modules/DataTable';

import { TransfersViewProps } from './Transfers.props';
import { useCountQuery } from 'components/primitives/StatCards/StatCard.container';
import { DateRangeInputExt } from 'components/modules/DateRangeInputExt';

import { buildTransferColumns, TransferRow } from './transfersColumns';

const TransferHubWashhub = `6552e877b476bf1a0f578a06`;

const TransfersView: FC<TransfersViewProps> = ({
  data,
  isFetching,
  handleRefetch,
  onSearchClear,
  onSearchPress,
  addDelayOnClose,
}) => {
  const transferFormModalRef = useRef<TransferModalRef>(null);

  const columns = useMemo(() => buildTransferColumns(), []);

  return (
    <Flex direction="column" flex={1} color="support.500" overflow="auto">
      <Flex alignItems="baseline" justify="space-between">
        <Heading fontSize="24px">Transfers</Heading>
        <Flex align="flex-end" gap="15px">
          <Button
            minW="200px"
            leftIcon={<MdMoveUp fontSize={'1.2rem'} />}
            onClick={() => {
              transferFormModalRef.current?.onOpen(0);
            }}>
            Transfer Out
          </Button>
          <Button
            minW="200px"
            leftIcon={<MdMoveDown fontSize={'1.2rem'} />}
            onClick={() => {
              transferFormModalRef.current?.onOpen(1);
            }}>
            Transfer In
          </Button>

          <UserPill />
        </Flex>
      </Flex>

      <DateRangeInputExt
        onSearchClear={onSearchClear}
        onSearchPress={onSearchPress}
      />

      <Flex align="flex-end" justify="space-between">
        <Counts />

        <Button onClick={handleRefetch}>Update Table</Button>
      </Flex>

      <DataTable<TransferRow>
        mt={6}
        data={data}
        columns={columns}
        minW="1400px"
        isLoading={isFetching}
        renderEmpty={() => (
          <Center p={8}>
            <Text fontSize="20px">No Transfers available</Text>
          </Center>
        )}
      />

      <TransferFormModal
        ref={transferFormModalRef}
        addDelayOnClose={addDelayOnClose}
      />
    </Flex>
  );
};

export default TransfersView;

const Counts: FC = () => {
  const items = useCountQuery('items', TransferHubWashhub);
  const cases = useCountQuery('cases', TransferHubWashhub);

  const itemsCount = Object.values<any>(items || {}).reduce(
    (acc, cur) => (acc || 0) + (cur || 0),
    0,
  );

  const casesCount = Object.values<any>(cases || {}).reduce(
    (acc, cur) => (acc || 0) + (cur || 0),
    0,
  );

  return (
    <Flex gap="20px">
      <Box
        p="10px 20px"
        bg="#3A2EC7"
        w="fit-content"
        color="#fff"
        fontWeight="bold"
        borderRadius="10px">
        Items ({itemsCount})
      </Box>

      <Box
        p="10px 20px"
        bg="#41C7A7"
        w="fit-content"
        color="#fff"
        fontWeight="bold"
        borderRadius="10px">
        Cases ({casesCount})
      </Box>

      <Box
        p="10px 20px"
        bg="#eb349b"
        w="fit-content"
        color="#fff"
        fontWeight="bold"
        borderRadius="10px">
        Packages (0)
      </Box>
    </Flex>
  );
};
